const messages = {
    pageTitle: 'Zlecenia w kooperacji',
    menuTitle: 'Zlecenia w kooperacji',

    filters: {
        searchNumber: 'Numer zlecenia lub zamówienia',
        status: 'Status',
        shippingDateFrom: 'Data wysyłki od',
        shippingDateTo: 'Data wysyłki do'
    },

    actions: {
        generateReport: 'Generuj raport',
        stocks: 'Stany magazynowe'
    },

    table: {
        headers: {
            number: 'Nr zlecenia',
            orderNumbers: 'Nr zamówień',
            shippingDate: 'Data wysyłki',
            status: 'Status',
            actions: 'Akcje'
        },
        actions: {
            details: 'Szczegóły zlecenia',
            delete: 'Usuń zlecenie'
        }
    },

    dialogs: {
        delete: {
            title: 'Usuwanie zlecenia w kooperacji',
            content: 'Czy na pewno chcesz usunąć zlecenie nr {number}?'
        }
    },

    details: {
        pageTitle: 'Szczegóły zlecenia',
        title: 'Zlecenie {number}',
        parametersTitle: 'Parametry zlecenia',
        fields: {
            number: 'Numer zlecenia',
            orderNumbers: 'Numery zamówień',
            shippingDate: 'Planowana data wysyłki',
            status: 'Status',
            printMethod: 'Sposób druku',
            material: 'Surowiec',
            materialFormat: 'Format surowca',
            weight: 'Waga',
            netAmount: 'Nakład netto',
            wastePerSetup: 'Makulatura na przyrząd',
            wastePerRun: 'Makulatura na bieg',
            colors: 'Kolorystyka',
            rasterType: 'Typ rastra',
            sheetCountStep: 'Liczenie arkuszy co'
        },
        actions: {
            backToList: 'Powrót do listy',
            printCards: 'Drukuj karty'
        },
        values: {
            colors: 'A: {sideA} / B: {sideB}'
        },
        validation: {
            consumptionQuantityRequired: 'Podaj ilość zużytego materiału.',
            consumptionQuantity: 'Wprowadź liczbę całkowitą większą od 0.'
        },
        materialConsumptions: {
            title: 'Zużycie surowców',
            quantity: 'Ilość',
            empty: 'Brak materiałów dostępnych w magazynie kooperanta.'
        },
        comments: {
            title: 'Komentarze do zlecenia',
            empty: 'Brak komentarzy do zlecenia.',
            addLabel: 'Dodaj komentarz',
            send: 'Wyślij',
            subtitle: '{author} – {date}'
        },
        orders: {
            accessDenied: 'Brak dostępu do zamówień kooperanta.',
            loadOrderError: 'Pobranie zamówienia nie powiodło się.',
            notFound: 'Nie znaleziono zamówienia o podanym numerze.',
            noStatus: 'Brak danych',
            retry: 'Ponów'
        },
        navigation: {
            unsaved: {
                title: 'Niezapisane zmiany',
                message: 'Masz niezapisane zmiany. Czy chcesz je porzucić?',
                stay: 'Pozostań na ekranie',
                discard: 'Porzuć zmiany'
            }
        }
    },

    stocks: {
        pageTitle: 'Stany magazynowe',
        table: {
            headers: {
                materialType: 'Rodzaj materiału',
                material: 'Nazwa / format materiału',
                unit: 'Jednostka miary',
                currentStock: 'Stan bieżący',
                minimumStock: 'Stan minimalny',
                status: 'Status',
                actions: 'Akcje'
            }
        },
        actions: {
            backToCooperationJobs: 'Powrót do zleceń w kooperacji',
            addStock: 'Dodaj stan',
            editStock: 'Edytuj'
        },
        dialog: {
            addTitle: 'Dodaj stan',
            editTitle: 'Edytuj stan',
            fields: {
                materialType: 'Rodzaj materiału',
                material: 'Materiał / format',
                currentStock: 'Stan bieżący',
                minimumStock: 'Stan minimalny'
            },
            validation: {
                required: 'Pole jest wymagane.',
                integer: 'Wprowadź liczbę całkowitą.',
                positive: 'Wartość musi być większa od 0.'
            }
        },
        notifications: {
            createSuccess: 'Stan został dodany.',
            updateSuccess: 'Stan został zapisany.'
        },
        errors: {
            fetchList: 'Pobranie stanów magazynowych nie powiodło się.',
            fetchDetails: 'Pobranie stanu magazynowego nie powiodło się.',
            fetchMaterialTypes: 'Pobranie rodzajów materiałów nie powiodło się.',
            create: 'Dodanie stanu nie powiodło się.',
            update: 'Zapisanie stanu nie powiodło się.'
        }
    },

    notifications: {
        reportSuccess: 'Po wygenerowaniu raport zostanie wysłany na adres {email}.',
        updateSuccess: 'Zlecenie zostało zapisane.',
        commentCreated: 'Dodano komentarz.',
        deleteSuccess: 'Zlecenie zostało usunięte.'
    },

    errors: {
        fetchList: 'Pobranie listy zleceń w kooperacji nie powiodło się.',
        fetchStatuses: 'Pobranie statusów zleceń w kooperacji nie powiodło się.',
        fetchConsumptionMaterialTypes: 'Pobranie materiałów do raportowania zużycia nie powiodło się.',
        generateReport: 'Wygenerowanie raportu nie powiodło się.',
        fetchDetails: 'Pobranie szczegółów zlecenia w kooperacji nie powiodło się.',
        printCards: 'Wygenerowanie kart zamówień nie powiodło się.',
        update: 'Zapisanie zlecenia w kooperacji nie powiodło się.',
        createComment: 'Dodanie komentarza nie powiodło się.',
        delete: 'Usunięcie zlecenia w kooperacji nie powiodło się.'
    }
}

export default {
    messages,
    locale: 'pl'
}
